import { useLazyQuery } from "@apollo/client";
import { Button } from "../../../../components/ui";
import { FETCH_ARTWORK_DESCRIPTIONS as fetchArtworkDescriptions } from "../../../../graphql/query/Artwork";

const CopyDescriptionBody = props => {
  const { closeModal, artwork, ids, type = null } = props;
  const [fetchArtworkDescription, { loading }] = useLazyQuery(
    fetchArtworkDescriptions(),
  );

  const handleClick = async () => {
    let descriptions = "";
    const result = await fetchArtworkDescription({
      variables: {
        input: {
          id: {
            operator: "in",
            value: artwork?.id ? [artwork.id] : ids,
          },
        },
      },
    });
    const edges = result?.data?.artworksV2?.edges || [];

    switch (type) {
      case "artistDescription":
        descriptions = edges
          .map(artwork => artwork?.artistDescription)
          .join("\n\n");
        break;
      case "archiveDescription":
        descriptions = edges
          .map(artwork => artwork?.archiveDescription)
          .join("\n\n");
        break;
      case "pressDescription":
        descriptions = edges
          .map(artwork => artwork?.pressDescription)
          .join("\n\n");
        break;
      default:
        descriptions = edges
          .map(artwork => artwork?.fullDescription)
          .join("\n\n");
    }

    navigator.clipboard.writeText(descriptions || "");
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        autoFocus
        disabled={loading}
        label={loading ? "Fetching description" : "Copy description"}
        onClick={handleClick}
      />
    </div>
  );
};

export default CopyDescriptionBody;
